import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Media", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.layoutDataEdit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.isVideo)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Enable Audio"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  class: "mt-1",
                  modelValue: _ctx.signageItemPlaySound,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemPlaySound) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_DigitalAssetUpload, {
          allowVideo: "true",
          sizeLimitMB: "300",
          layoutProperty: "img",
          layoutType: _ctx.layoutType,
          assetUrl: _ctx.assetUrl,
          onIsUploadingVideo: _ctx.updatePlaySound
        }, null, 8, ["layoutType", "assetUrl", "onIsUploadingVideo"])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}